var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 360,
    height: 338,
    viewBox: "0 0 360 338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F2F5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C6DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "56.55%",
    x2: "43.6%",
    y1: "68.36%",
    y2: "37.99%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#77CDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.88%",
    stopColor: "#0098E9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M145.19 85.74L112 0 0 64.42l33.2 85.64z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "116.5%",
    height: "116%",
    x: "-4.1%",
    y: "-7.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F2F5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C6DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "3.45%",
    y1: "59.54%",
    y2: "40.09%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6B97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFAF8C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M103.04 38.94L15.2 89.5c-.76.43-1.57.12-1.87-.72L.09 53.02a2 2 0 0 1 .82-2.26L88.78.19c.75-.42 1.57-.12 1.87.72l13.2 35.76c.3.82-.09 1.84-.81 2.27z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#252B4F",
    fillRule: "nonzero",
    d: "M357.52 220.06l-160.77 93.77L24.28 216l162.52-93.54z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAF1FA",
    d: "M334.85 167.54l23.3 51.07a1.33 1.33 0 0 1-1.84 1.72l-39.87-21.05 16.58-24.81 1.83-6.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF6FF",
    d: "M332.62 168.59l20.4 45.47c.2.48-.31.93-.77.7l-41.89-22.14 17.18-22.98 5.08-1.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DFFE",
    d: "M331 169.1l6.34 3.5-5.35 9.22-5.48-2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DFFE",
    d: "M312.12 190.3l38.99 20.74-15.93-35.49.23-.64 17.6 39.18c.21.48-.3.93-.76.7l-41.89-22.14 1.76-2.35z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M239.7 150.25L183.79 5.85l2.78-3.2-6.29-2.02a5.41 5.41 0 0 0-5.2.12L2.93 99.84a5.42 5.42 0 0 0-2.36 6.66L41.9 213.06a6.48 6.48 0 0 1 2.7 3.26l5.62 14.5c.45 1.18.58 2.48.3 3.74l-.12.51 6.66 17.2a5.46 5.46 0 0 0 3.63 3.28l6.05 1.9.2-3.65 170.9-98.36a4.21 4.21 0 0 0 1.88-5.19z",
    transform: "matrix(-1 0 0 1 359.94 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M350.62 102.76L177.58 3.2a5.46 5.46 0 0 0-7.8 2.74l-56.48 145.8a5.4 5.4 0 0 0 2.36 6.65l172.1 99.03a5.46 5.46 0 0 0 7.81-2.75l56.9-146.72a4.23 4.23 0 0 0-1.85-5.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "nonzero",
    d: "M228.91 140.21l-47.4-122.57-160.03 92.09L68.9 232.15z",
    transform: "matrix(-1 0 0 1 359.94 0)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "matrix(-1 0 0 1 303.76 48.3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "evenodd",
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F0FA",
    fillRule: "nonzero",
    d: "M188.22 57.35l3.53-9.06 112.01 64.42-3.88 10.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F0FA",
    fillRule: "nonzero",
    d: "M188.22 57.35l3.53-9.06 112.01 64.42-3.88 10.07zm14.43 45.13l1.98-5.03 62.84 35.8-2.18 5.6zm12.99-11.93l49.23 28.29-2.73 7.07-49.12-28.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD6F8D",
    d: "M296.77 117.28c.36-.02.68-.15.95-.42.28-.26.5-.61.66-1.07a3 3 0 0 0 .18-1.34 2.57 2.57 0 0 0-1.34-2.03 2.07 2.07 0 0 0-1.14-.3c-.36.02-.68.15-.95.41a3.34 3.34 0 0 0-.86 2.42c.01.44.15.82.38 1.17s.55.63.93.85c.43.25.82.33 1.19.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#08CA73",
    d: "M290.72 113.83c.36-.02.68-.15.95-.41.28-.27.5-.62.66-1.08.16-.46.23-.9.19-1.34a2.57 2.57 0 0 0-1.35-2.03 2.07 2.07 0 0 0-1.14-.3c-.36.02-.68.15-.95.41a3.34 3.34 0 0 0-.86 2.42c.02.44.15.82.38 1.17s.55.64.93.86c.44.24.82.32 1.19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DFFE",
    fillRule: "nonzero",
    d: "M328.06 183.24l-8.26 21.2c-.15.42-.64.57-1.03.36h-.03c-.3-.18-.42-.54-.3-.84l8.29-21.23a.7.7 0 0 1 1-.36c.33.18.45.54.33.87z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C6DFFE",
    d: "M292.73 252.6l4.99-13.24-175.68-101.02-5.56 13.7a2.98 2.98 0 0 0 1.3 3.73l170.6 98.36c1.63.94 3.68.21 4.35-1.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M175.52 2.71L2.6 102.46l3.63 9.65a2.98 2.98 0 0 0 4.27 1.54L178.46 16.8a3 3 0 0 0 1.27-3.68l-4.2-10.4z",
    transform: "matrix(-1 0 0 1 297.93 138.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DFFE",
    d: "M2.72 234.05l165.72 95.28a9.13 9.13 0 0 0 9.86-.5l117.82-85.25 1.6-4.25-176.89-97.1L2.4 227.96a3.65 3.65 0 0 0 .33 6.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF6FF",
    d: "M3.32 233.17l162 93.15a12.12 12.12 0 0 0 13.16-.7l119.24-86.26-175.68-101.02L2.9 224.58a5.11 5.11 0 0 0 .42 8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8E3F8",
    d: "M204.79 294.09l76.72-55.58-156.44-90.06-79.15 57.36zM71.74 263.12l36.87 21.2 26.35-19.1-36.87-21.19z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M327.15 275.96v4.62l-91.47 52.67v-4.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C6D8",
    d: "M323.16 273.64l3.99 2.32-91.47 52.68-4.02-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6ADCB",
    d: "M323.16 273.64l.03.03c1.18-.66 3.02.33 4.14 2.23 1.12 1.9 1.03 4.01-.15 4.7-.06.04-.15.07-.21.1l-11.89 6.84c1.18-.7 1.24-2.77.12-4.7-1.12-1.9-2.96-2.93-4.14-2.23h-.03l12.13-6.97zm-91.5 52.71c-4 2.29-11.62 10.43-10.89 10.85.7.43 10.89-1.6 14.91-3.92 4.02-2.35-.03-9.25-4.02-6.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8E97B9",
    d: "M235.65 333.28c1.18-.69 1.24-2.77.15-4.7-1.09-1.93-2.96-2.9-4.14-2.23l2-1.18a6.03 6.03 0 0 1 3.17 2.8c.85 1.45 1.12 3 .85 4.14l-2.03 1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C6D8",
    d: "M312.48 286.21v1c0 .48-.24.9-.67 1.15l-60.55 34.88a.44.44 0 0 1-.67-.39v-1c0-.48.25-.9.67-1.14l60.55-34.86c.28-.18.67.03.67.36z"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    fillRule: "nonzero",
    transform: "matrix(-1 0 0 1 270.55 107.57)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M188.5 141.3a8.05 8.05 0 0 1-1.5-1.84l1.47-1.38a8.36 8.36 0 0 0 2.86 2.85c.56.33 1.02.5 1.37.53.36.02.58-.1.68-.39.09-.25.02-.54-.2-.86a8.2 8.2 0 0 0-1.35-1.39 12.29 12.29 0 0 1-1.96-2 3.89 3.89 0 0 1-.76-1.62c-.08-.5-.02-1 .16-1.54.21-.6.58-1.05 1.1-1.34a2.95 2.95 0 0 1 1.85-.28c.72.1 1.48.38 2.29.85.71.43 1.38.94 1.98 1.54.61.6 1.05 1.18 1.32 1.74l-1.46 1.38a8.23 8.23 0 0 0-1.14-1.53 6.39 6.39 0 0 0-1.37-1.1 2.4 2.4 0 0 0-1.25-.42c-.35.01-.58.17-.69.48a.74.74 0 0 0 .01.51c.06.18.22.4.46.67.24.27.62.64 1.14 1.1.84.72 1.47 1.38 1.89 1.96a4 4 0 0 1 .76 1.62c.09.5.04 1-.14 1.51-.34.98-.98 1.51-1.93 1.62-.95.1-2.1-.24-3.48-1.06a11.4 11.4 0 0 1-2.11-1.6zm7.95 4.92l3.47-9.97 2.63 1.56-3.47 9.97-2.63-1.56zm15.23 2.24l-1.74 5a8.7 8.7 0 0 1-1.98-.5c-.7-.26-1.4-.6-2.09-1a8.72 8.72 0 0 1-2.6-2.3 6.36 6.36 0 0 1-.91-5.98 4.7 4.7 0 0 1 1.57-2.3c.7-.52 1.51-.75 2.44-.7a6.4 6.4 0 0 1 2.96 1c.72.42 1.37.92 1.94 1.48.58.57 1 1.14 1.3 1.7l-1.48 1.37a8.35 8.35 0 0 0-1.1-1.43c-.37-.39-.8-.73-1.3-1.01-.88-.53-1.63-.67-2.23-.43-.61.24-1.1.88-1.45 1.9a4.16 4.16 0 0 0-.15 2.77 3.9 3.9 0 0 0 1.83 2.01c.44.26.9.48 1.36.64l.65-1.85-1.74-1.02.62-1.78 4.1 2.43zm9.62.46l2.48 1.47-3.47 9.97-1.95-1.16-2.55-8.33-1.97 5.66-2.45-1.46 3.47-9.96 1.92 1.13 2.56 8.31 1.96-5.63zm6.29 14.58a5.3 5.3 0 0 1 0-3.9l2.01-5.76 2.56 1.52-2.04 5.87a2.98 2.98 0 0 0-.1 1.93c.2.58.59 1.04 1.19 1.4.58.34 1.1.42 1.56.22.45-.2.8-.66 1.05-1.36l2.04-5.87 2.59 1.53-2.01 5.77c-.49 1.4-1.24 2.25-2.26 2.54-1.02.29-2.24.01-3.67-.83a6.66 6.66 0 0 1-2.92-3.06zm12.58-3.4l4.75 2.82a5.7 5.7 0 0 1 2.36 2.38c.43.92.49 1.85.16 2.78-.32.92-.9 1.47-1.72 1.65-.83.17-1.8-.07-2.92-.74l-2.11-1.25-1.36 3.9-2.63-1.57 3.47-9.97zm2.96 6.73c1 .58 1.61.52 1.85-.18.13-.35.1-.69-.07-1.01a2.69 2.69 0 0 0-1.03-.94l-1.77-1.05-.74 2.13 1.76 1.05z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.6bf7413f6f254dcd119b0005b1a72ccb.svg";
export { ForwardRef as ReactComponent };